import { Button } from "@circleco/compass/components/Button";
import { TextArea } from "@circleco/compass/components/TextArea";
import { useState } from "react";

import { t } from "@/i18n-js/instance";

interface RejectReasonPopoverContentProps {
  i18nRoot: string;
  isRejecting: boolean;
  onSubmit: (reason: string | null) => void;
  rejectLabel: string;
}

export const RejectReasonPopoverContent = ({
  i18nRoot,
  isRejecting,
  onSubmit,
  rejectLabel,
}: RejectReasonPopoverContentProps) => {
  const [reason, setReason] = useState("");

  return (
    <div className="flex flex-col gap-3">
      <TextArea
        label={t([i18nRoot, "moderation_note"])}
        rows={3}
        resize="none"
        placeholder={t([i18nRoot, "rejection_note_placeholder"])}
        value={reason}
        onChange={event => setReason(event.target.value)}
      />
      <Button
        type="button"
        variant="primary"
        fullWidth
        disabled={isRejecting}
        onClick={() => onSubmit(reason || null)}
      >
        {rejectLabel}
      </Button>
    </div>
  );
};
